<div class="page">
  <header class="brijjsports-page-head">
    <p class="brijjsports-page-kicker">Coach · Basketball</p>
    <h1 class="brijjsports-page-title">New game</h1>
    <p class="brijjsports-page-sub">Create a basketball game and pick your roster.</p>
  </header>

  <mat-stepper class="brijjsports-card" linear>
    <mat-step [stepControl]="basicsForm" label="Game info">
      <form [formGroup]="basicsForm" class="bb-form">
        <mat-form-field appearance="outline">
          <mat-label>Game name</mat-label>
          <input matInput formControlName="name" maxlength="80" required />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Opponent</mat-label>
          <input matInput formControlName="opponent" maxlength="60" required />
        </mat-form-field>

        <div class="bb-form__group">
          <span class="bb-form__legend">Format</span>
          <mat-radio-group formControlName="quarterCount" aria-label="Format">
            <mat-radio-button [value]="2">Halves (2)</mat-radio-button>
            <mat-radio-button [value]="4">Quarters (4)</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="form-actions">
          <button mat-flat-button color="primary" matStepperNext type="button" [disabled]="basicsForm.invalid">
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <mat-step label="Roster">
      <p class="brijjsports-muted">Select players who will play in this game.</p>

      @if (basketballAthletes().length === 0) {
        <p class="brijjsports-empty">No basketball athletes yet. Add players to your roster first.</p>
      } @else {
        <ul class="bb-roster">
          @for (a of basketballAthletes(); track a.id) {
            <li class="bb-roster__row">
              <mat-checkbox [checked]="isSelected(a.id)" (change)="toggleAthlete(a.id, $event.checked)">
                <span class="bb-roster__name">{{ a.name }}</span>
                <span class="brijjsports-muted">age {{ a.age }} {{ a.school ? '· ' + a.school : '' }}</span>
              </mat-checkbox>
            </li>
          }
        </ul>
      }

      <div class="form-actions">
        <button mat-button matStepperPrevious type="button">Back</button>
        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="create()"
          [disabled]="!canFinish() || creating()"
        >
          <mat-icon>play_arrow</mat-icon>
          Tip-off
        </button>
      </div>
    </mat-step>
  </mat-stepper>
</div>
